import { Toaster } from "ui-widgets";
import User from "datalign-module-template/models/user";

export default class AuthService {
  static siteletHeaders: HeadersInit = {
    "Content-Type": "application/json",
    "sitelet-guid": process.env.REACT_APP_SITELET_GUID ?? "",
  };
  static CurrentUser?: User;
  //Just catches the auth error
  async current_user() {
    const r = await fetch(`${process.env.REACT_APP_API_HOST}/user/current`, {
      method: "GET",
      credentials: "include",
      headers: AuthService.siteletHeaders,
    });
    if (r.ok) {
      const resp = await r.json();

      if (resp?.errors) {
        Toaster.makeToast("Error on getting current user", "error");
      }
      return resp.data as User;
    }
  }

  // async logout() {
  //   const r = await fetch(
  //     `${process.env.REACT_APP_API_HOST}/user/logout`,
  //     {
  //       method: "POST",
  //       credentials: "include",
  //       headers: AuthService.siteletHeaders,
  //     },
  //   );
  //   if (r.ok) {
  //     const resp = await r.json();

  //     if (resp?.errors) {
  //       Toaster.makeToast("Error on logging out", "error");
  //     }
  //     Toaster.makeToast(resp.message ?? "User logged out!");
  //   }
  // }
}
